const initializeFaq = (faq) => {
  faq.querySelectorAll('details').forEach((item) => {
    const control = item.querySelector('summary');
    if (!control) return;

    const syncExpandedState = () => control.setAttribute('aria-expanded', String(item.open));
    item.addEventListener('toggle', syncExpandedState);
    syncExpandedState();
  });
};

document.querySelectorAll('[data-blackland-faq]').forEach(initializeFaq);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-blackland-faq]').forEach(initializeFaq);
});
